export default __webpack_public_path__ + "static/media/36k.db8444cc.md";